// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function makeIdGenerator(param) {
  var nextId = {
    contents: 0
  };
  return function (param) {
    var id = nextId.contents;
    nextId.contents = id + 1 | 0;
    return id;
  };
}

exports.makeIdGenerator = makeIdGenerator;
/* No side effect */
